import Vue from "vue";
import VueRouter from "vue-router";
import StepOne from "./steps/stepone";
import StepTwo from "./steps/steptwo";
import StepThree from "./steps/stepthree";
import StepFour from "./steps/stepfour";
import StepFive from "./steps/stepfive";
import StepSix from "./steps/stepsix";
import StepSeven from "./steps/stepseven";
import Vuelidate from "vuelidate";
import Vuex from "vuex";
import VueYouTubeEmbed from "vue-youtube-embed";
Vue.use(VueYouTubeEmbed);
Vue.use(Vuex);
Vue.use(Vuelidate);
Vue.use(VueRouter);
import App from "./App.vue";

const router = new VueRouter({
  mode: "abstract",
  routes: [
    { path: "/", component: StepOne },
    { name: "steptwo", path: "/steptwo", component: StepTwo },
    { name: "stepthree", path: "/stepthree", component: StepThree },
    { name: "stepfour", path: "/stepfour", component: StepFour },
    { name: "stepfive", path: "/stepfive", component: StepFive },
    { name: "stepsix", path: "/stepsix", component: StepSix },
    { name: "stepseven", path: "/stepseven", component: StepSeven }
  ]
});

Vue.config.productionTip = false;

const store = new Vuex.Store({
  state: {
    price: Math.round(Math.random()) ? 5000 : 50,
    guess: 1000,
    groupA: 150,
    groupB: 2400,
    total: 120
  },
  mutations: {
    setGuess(state, n) {
      state.guess = n;
    },
    setGroupA(state, n) {
      state.groupA = n;
    },
    setGroupB(state, n) {
      state.groupB = n;
    },
    setTotal(state, n) {
      state.total = n;
    }
  }
});

new Vue({
  render: h => h(App),
  router,
  store
}).$mount("#app");

router.replace("/");
